/**
 *  ToggleButton script file
**/

export default {
  name: 'ToggleButton',
  mixins: [],
  components: {},
  props: {
    buttons: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'text',
      required: false,
      validator (value) {
        const options = [
          'text',
          'icon',
          'icon-text',
          'text-icon'
        ]
        return options.indexOf(value) !== -1
      }
    },
    size: {
      type: String,
      default: 'default',
      required: false,
      validator (value) {
        const options = [
          'small',
          'default',
          'large'
        ]
        return options.indexOf(value) !== -1
      }
    },
    selected: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    selectButton (opt) {
      this.$emit('selected', opt)
    }
  }
}
